import type { WizardState } from './types';

/**
 * The wizard's initial state.
 *
 * Deliberately not persisted to localStorage: the form carries an owner's
 * apartment address and interior photos, and leaving that in a shared browser
 * after the tab closes is a liability, not a convenience. Progress survives
 * back/forward between steps because it lives at the App level.
 */
export function createInitialState(): WizardState {
  return {
    apartment: {
      address: '',
      lat: null,
      lng: null,
      anConstructie: '',
      tipImobil: '',
      etaj: '',
      etajeTotal: '',
      suprafataUtila: '',
      numarCamere: '',
      incadrareSeismica: '',
      lift: false,
      compartimentare: '',
      balcon: '',
      suprafataBalcon: '',
      sursaIncalzire: '',
      suprafataTeren: '',
      structura: '',
      incalzire: '',
    },
    condition: {
      stareActuala: '',
      situatieJuridica: '',
      intentieNote: '',
    },
    contact: {
      name: '',
      email: '',
      phone: '',
      consent: false,
    },
    files: {
      photos: [],
      plan: null,
    },
  };
}
